import * as n from "react";
import { u as O, c as S, a as D } from "./index-D7uzFyzw.js";
import { c as M, P as v, u as L } from "./index-Bud8rdvZ.js";
import { u as k, P as F } from "./index-B6DkbY8I.js";
import { jsx as c } from "react/jsx-runtime";
var f = "Collapsible", [B, J] = M(f), [G, g] = B(f), T = n.forwardRef(
  (e, s) => {
    const {
      __scopeCollapsible: r,
      open: a,
      defaultOpen: t,
      disabled: l,
      onOpenChange: i,
      ...m
    } = e, [p, d] = O({
      prop: a,
      defaultProp: t ?? !1,
      onChange: i,
      caller: f
    });
    return /* @__PURE__ */ c(
      G,
      {
        scope: r,
        disabled: l,
        contentId: k(),
        open: p,
        onOpenToggle: n.useCallback(() => d((C) => !C), [d]),
        children: /* @__PURE__ */ c(
          v.div,
          {
            "data-state": h(p),
            "data-disabled": l ? "" : void 0,
            ...m,
            ref: s
          }
        )
      }
    );
  }
);
T.displayName = f;
var w = "CollapsibleTrigger", A = n.forwardRef(
  (e, s) => {
    const { __scopeCollapsible: r, ...a } = e, t = g(w, r);
    return /* @__PURE__ */ c(
      v.button,
      {
        type: "button",
        "aria-controls": t.contentId,
        "aria-expanded": t.open || !1,
        "data-state": h(t.open),
        "data-disabled": t.disabled ? "" : void 0,
        disabled: t.disabled,
        ...a,
        ref: s,
        onClick: S(e.onClick, t.onOpenToggle)
      }
    );
  }
);
A.displayName = w;
var R = "CollapsibleContent", I = n.forwardRef(
  (e, s) => {
    const { forceMount: r, ...a } = e, t = g(R, e.__scopeCollapsible);
    return /* @__PURE__ */ c(F, { present: r || t.open, children: ({ present: l }) => /* @__PURE__ */ c($, { ...a, ref: s, present: l }) });
  }
);
I.displayName = R;
var $ = n.forwardRef((e, s) => {
  const { __scopeCollapsible: r, present: a, children: t, ...l } = e, i = g(R, r), [m, p] = n.useState(a), d = n.useRef(null), C = L(s, d), P = n.useRef(0), y = P.current, x = n.useRef(0), N = x.current, b = i.open || m, _ = n.useRef(b), u = n.useRef(void 0);
  return n.useEffect(() => {
    const o = requestAnimationFrame(() => _.current = !1);
    return () => cancelAnimationFrame(o);
  }, []), D(() => {
    const o = d.current;
    if (o) {
      u.current = u.current || {
        transitionDuration: o.style.transitionDuration,
        animationName: o.style.animationName
      }, o.style.transitionDuration = "0s", o.style.animationName = "none";
      const E = o.getBoundingClientRect();
      P.current = E.height, x.current = E.width, _.current || (o.style.transitionDuration = u.current.transitionDuration, o.style.animationName = u.current.animationName), p(a);
    }
  }, [i.open, a]), /* @__PURE__ */ c(
    v.div,
    {
      "data-state": h(i.open),
      "data-disabled": i.disabled ? "" : void 0,
      id: i.contentId,
      hidden: !b,
      ...l,
      ref: C,
      style: {
        "--radix-collapsible-content-height": y ? `${y}px` : void 0,
        "--radix-collapsible-content-width": N ? `${N}px` : void 0,
        ...e.style
      },
      children: b && t
    }
  );
});
function h(e) {
  return e ? "open" : "closed";
}
var K = T, Q = A, U = I;
export {
  U as C,
  K as R,
  Q as T,
  J as c
};
